import { useEffect, useState } from 'react';

import { ArrowDown01Icon, ArrowUp01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Collapse } from 'react-bootstrap';

import { Toggle } from '../FormComponents';
import styles from './EditableSettings.module.scss';

export const EditableSettings = ({
  title,
  className,
  children,
  open,
  toggleable = false,
  name,
  onChange,
  register = () => {},
}) => {
  const [localOpen, setLocalOpen] = useState(open);

  useEffect(() => {
    setLocalOpen(open);
  }, [open]);

  return (
    <div
      className={cn(
        'flex flex-col bg-neutral-1 rounded-3xl border border-neutral-4 shadow-sm overflow-hidden',
        className,
      )}>
      <header
        className={`flex items-center justify-between px-4 py-2 bg-neutral-2 border-b border-neutral-4 ${localOpen ? 'border-b-neutral-4' : 'border-b-transparent'}`}>
        <div className="u-flex-box u-flex-align-center">
          {toggleable && onChange && (
            <Toggle
              className={cn('u-margin-right--small')}
              inputProps={{ checked: open, onChange }}
            />
          )}
          {toggleable && !onChange && (
            <Toggle className={cn('u-margin-right--small')} name={name} register={register} />
          )}
          <span className="text-neutral-6 text-xl font-medium">{title}</span>
        </div>
        <div className={styles.iconWrapper}>
          <HugeiconsIcon
            icon={localOpen ? ArrowUp01Icon : ArrowDown01Icon}
            onClick={() => {
              setLocalOpen(!localOpen);
            }}
          />
        </div>
      </header>
      <Collapse in={localOpen}>
        <div>
          <div className={cn(styles.body, 'p-4')}>{children}</div>
        </div>
      </Collapse>
    </div>
  );
};

EditableSettings.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  toggleable: PropTypes.bool,
  register: PropTypes.func,
  name: PropTypes.string,
  onChange: PropTypes.func,
};
